import type {UseFormReturn} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  FormRequiredLegend,
} from '@/components/ui/form';
import {Textarea} from '@/components/ui/textarea';
import type {ResidentStatus} from '@/services/graphqlHooks';

import type {MarkResidentAsAbsentFormValues} from '../utils/residentFormInputs';
import ResidentInput from './ResidentInput';

export type MarkResidentAsAbsentFormFieldsProps = {
  form: UseFormReturn<MarkResidentAsAbsentFormValues>;
  allowedStatuses: ResidentStatus[];
};

const MarkResidentAsAbsentFormFields = ({
  form,
  allowedStatuses,
}: MarkResidentAsAbsentFormFieldsProps) => {
  const {t} = useTranslation();

  return (
    <>
      <FormRequiredLegend />

      <FormField
        control={form.control}
        name="id"
        render={({field}) => (
          <FormItem>
            <FormLabel required>{t('Resident')}</FormLabel>
            <FormControl>
              <ResidentInput
                allowedStatuses={allowedStatuses}
                value={field.value}
                onChange={field.onChange}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="content"
        render={({field}) => (
          <FormItem>
            <FormLabel required>{t('Description')}</FormLabel>
            <FormControl>
              <Textarea {...field} required />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default MarkResidentAsAbsentFormFields;
